import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  VisaDocumentDeleteMutationInput,
  VisaDocumentModel,
  VisaDocumentMutationInput,
  VisaDocumentUpdateMutationInput,
} from './model';

const BASE_URL = 'visa-documents';

export function useCreateVisaDocument(
  options?: UseMutationOptions<
    ApiResult<VisaDocumentModel>,
    ApiError,
    VisaDocumentMutationInput
  >,
): UseMutationResult<
  ApiResult<VisaDocumentModel>,
  ApiError,
  VisaDocumentMutationInput
> {
  return useMutation<
    ApiResult<VisaDocumentModel>,
    ApiError,
    VisaDocumentMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      method: 'POST',
      url: BASE_URL,
      body,
      classType: VisaDocumentModel,
    });
  }, options);
}

export function useUpdateVisaDocument(
  options?: UseMutationOptions<
    ApiResult<VisaDocumentModel>,
    ApiError,
    VisaDocumentUpdateMutationInput
  >,
): UseMutationResult<
  ApiResult<VisaDocumentModel>,
  ApiError,
  VisaDocumentUpdateMutationInput
> {
  return useMutation<
    ApiResult<VisaDocumentModel>,
    ApiError,
    VisaDocumentUpdateMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      method: 'PUT',
      url: `${BASE_URL}/${body.id}`,
      body: body.body,
      classType: VisaDocumentModel,
    });
  }, options);
}

export function useDeleteVisaDocument(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    VisaDocumentDeleteMutationInput
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  VisaDocumentDeleteMutationInput
> {
  return useMutation<ApiResult<any>, ApiError, VisaDocumentDeleteMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        method: 'DELETE',
        url: `${BASE_URL}/${body.id}`,
      });
    },
    options,
  );
}
